import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader" role="status" aria-label="Loading">
        <span className="loader-ring" />
        <span className="loader-label">Loading</span>
      </div>
    </div>
  );
};

export default Loader;
